import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import { FiChevronRight } from "react-icons/fi";
import "./DomainsContent.css";
import DomainsTabsNew from "./DomainsTabsNew";
import AOS from "aos";
import "aos/dist/aos.css";

function DomainsContent({bannerimg}) {
  useEffect(() => {
    AOS.init({ duration: 800 });
  }, []);
  return (
    <>
      <div className="main-banner">
        <img
          src={bannerimg}
          alt="banner"
          className="banner-img"
        />
      </div>
      <div className="Domains-tabs-sec" id="DomainsTab">
        <div className="Domains-tabs-wrap">
          <ul className="breadcrumbs">
            <li className="breadcrumbs-item">
              <NavLink
                activeClassName="is-active"
                className="breadcrumbs-links"
                to="/home"
              >
                Home
              </NavLink>
              <span>
                <FiChevronRight />
              </span>
            </li>
            <li className="breadcrumbs-item">
              <a
                activeClassName="is-active"
                className="breadcrumbs-links"
                href="/VodafoneTalentAcademy/home#Roles"
              >
                Roles
              </a>
              <span>
                <FiChevronRight />
              </span>
            </li>
            {/* <li className="breadcrumbs-item">
              <NavLink
                activeClassName="is-active"
                className="breadcrumbs-links"
                to="/Roles"
              >
                Role-based Learning
              </NavLink>
            </li> */}
          </ul>
          {/* <div className="Domains-tabs-row">
            <h2>Role-based Learning</h2>
           
            <p>
              Welcome to our Role-based Learning program, where education aligns
              with industry needs. Tailored for specific roles, this initiative
              ensures targeted skill development, empowering individuals with
              the precise knowledge and competencies required for success. Dive
              into a curated curriculum in the{" "}
              <span> Engineering and Enterprise domain </span>
              designed for{" "}
              <span>
                {" "}
                roles in Data Engineering, Data Science, Python Programming,{" "}
              </span>
              and more, providing a strategic and career-centric approach to
              learning. Elevate your professional journey by acquiring
              role-specific expertise and staying ahead in today's dynamic job
              market.
            </p>
          </div>
          <div className="elevate-wrap">
            <h2>Elevate Your Proficiency!</h2>
            <img
              src="images/Domains/elevate-border.png"
              alt="elevate"
              className="elevate-border"
            />
            <p>
              Rise above the ordinary and soar into excellence with our curated
              learning experiences. Your journey to mastery starts here - seize
              the opportunity to ascend and stand out in the rapidly evolving
              landscape of technology.
            </p>
            <p>
              Participate in the mandatory pre-assessment tailored to your job
              role within your domain. Learning paths are provided to you,
              serving as roadmaps to help elevate your proficiency.
            </p>
            <img
              src="images/Domains/elevate-info-new-final.png"
              alt="elevate"
              className="elevate-info"
            />
          </div> */}
          <DomainsTabsNew />
        </div>
      </div>
    </>
  );
}

export default DomainsContent;
